import React, { useState } from 'react'
import { Person, Settings } from '@mui/icons-material'
import { Divider, IconButton, ListSubheader, Menu, MenuItem, Stack } from '@mui/material'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import Colors from 'utils/Colors'

import styles from './styles'

function MenuAvatar(props) {
  const { username, options } = props
  const classes = styles()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  function handleOpen(event) {
    setAnchorEl(event.currentTarget)
  }

  return (
    <div className={classes.root}>
      <Person fontSize="medium" htmlColor={Colors.gray} style={{ marginRight: 5 }} />
      <span className={classes.name}>{username.toLowerCase()}</span>
      <IconButton onClick={handleOpen}  style={{ marginLeft: 10 }} >
        <Settings fontSize="large" htmlColor={Colors.white}  />
      </IconButton>
      <Menu
        id="options-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.menu}
      >
        <ListSubheader>
          <Stack direction='row' spacing={2} alignItems='center' >
            <Settings fontSize='small'></Settings>
            <strong style={{ fontSize: 'medium' }}>Opções</strong>
          </Stack>
        </ListSubheader>
        <Divider></Divider>
        {addKeyToObjectsArray(options)?.map((option) => (
          <MenuItem key={option.key} onClick={option.action}>
            <Stack direction='row' spacing={2} alignItems='center' >
              <span className={classes.option}>{option.icon}</span>
              <span className={classes.option}>{option.text}</span>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default MenuAvatar
